<script>
import { VRadioGroup } from 'vuetify/lib'

export default {
  name: 'ERadioGroup',
  extends: VRadioGroup,
  props: {
    hideDetails: {
      type: [Boolean, String],
      default: 'auto',
    },
  },
}
</script>
